import React, { useEffect, useMemo, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/notification-template/notificationTemplateAction";
import * as uiHelpers from "../NotificationTemplateUIHelpers";

import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  toastOption
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { useNotificationTemplateUIContext } from "../NotificationTemplateUIContext";
import { RoleChecker } from "../../../../../RoleChecker";
import {
  notificationTemplateStatusFormatter,
  ORGANIZATION_STATUS
} from "../../../../../config/helper";
import { ConfirmationModal } from "../../../../Donation/pages/confirmation/confirmation-edit/confirmation-edit-form/ConfirmationModal";
import { toast } from "react-toastify";
import ConfirmationDeleteModal from "../../../../Project/pages/modal-for-project/ConfirmationDeleteModal";
// import { ToastContainer } from 'react-toastify';

const NotificationTemplateTable = ({ allowEdit, allowDelete }) => {
  const [confirmationModal, setConfirmationModal] = useState({
    updateStatus: false,
    delete: false
  });
  const [currentItem, setCurrentItem] = useState({});

  // NotificationTemplate UI Context
  const notificationTemplateUIContext = useNotificationTemplateUIContext();
  const notificationTemplateUIProps = useMemo(() => {
    return {
      queryParams: notificationTemplateUIContext.queryParams,
      setQueryParams: notificationTemplateUIContext.setQueryParams,
      openEditNotificationTemplatePage:
        notificationTemplateUIContext.openEditNotificationTemplatePage,
      openNotificationTemplateFilePage:
        notificationTemplateUIContext.openNotificationTemplateFilePage
    };
  }, [notificationTemplateUIContext]);

  // Getting curret state of notificationTemplate list from store (Redux)
  const { currentState } = useSelector(
    state => ({ currentState: state.superadminNotificationTemplates }),
    shallowEqual
  );

  const { totalCount, entities, listLoading } = currentState;

  const dispatch = useDispatch();
  useEffect(() => {
    //Requset ke Branch Action
    dispatch(
      actions.fetchNotificationTemplates(
        notificationTemplateUIProps.queryParams
      )
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notificationTemplateUIProps.queryParams, dispatch]);

  // Table columns
  const columns = [
    {
      dataField: "name",
      text: "Name",
      sort: true
      // sortCaret: sortCaret,
    },
    {
      dataField: "type",
      text: "Tipe",
      sort: true
      // sortCaret: sortCaret,
    },
    {
      dataField: "is_active",
      text: "Status",
      sort: true,
      formatter: (cell, row) => {
        let color;
        if (cell) {
          color = "success";
        } else {
          color = "danger";
        }
        return (
          <span className={`label label-lg label-light-${color} label-inline`}>
            {cell ? "AKTIF" : "TIDAK AKTIF"}
          </span>
        );
      }
    },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditNotificationTemplatePage:
          notificationTemplateUIProps.openEditNotificationTemplatePage,
        openNotificationTemplateFilePage:
          notificationTemplateUIProps.openNotificationTemplateFilePage,
        allowEdit,
        allowDelete,
        setConfirmationModal,
        setCurrentItem
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px"
      }
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: notificationTemplateUIProps.queryParams.pageSize,
    page: notificationTemplateUIProps.queryParams.pageNumber
  };

  const updateStatusTemplate = () => {
    const data = {
      uuid: currentItem.uuid,
      is_active: currentItem.is_active ? false : true
    };
    dispatch(actions.updateStatusNotificationTemplate(data))
      .then(res => {
        toast.success(res.data.message, toastOption);
        dispatch(
          actions.fetchNotificationTemplates(
            notificationTemplateUIProps.queryParams
          )
        );
        setCurrentItem({});
        setConfirmationModal(prev => ({
          ...prev,
          delete: false,
          updateStatus: false
        }));
      })
      .catch(err => {
        toast.error("Failed to update notification template", toastOption);
        setCurrentItem({});
        setConfirmationModal(prev => ({
          ...prev,
          delete: false,
          updateStatus: false
        }));
      });
  };

  const deleteTemplate = () => {
    dispatch(actions.deleteNotificationTemplate(currentItem.uuid))
      .then(res => {
        toast.success(res.data.message, toastOption);
        dispatch(
          actions.fetchNotificationTemplates(
            notificationTemplateUIProps.queryParams
          )
        );
        setCurrentItem({});
        setConfirmationModal(prev => ({
          ...prev,
          delete: false,
          updateStatus: false
        }));
      })
      .catch(err => {
        toast.error("Failed to update notification template", toastOption);
        setCurrentItem({});
        setConfirmationModal(prev => ({
          ...prev,
          delete: false,
          updateStatus: false
        }));
      });
  };

  return (
    <>
      <ConfirmationModal
        onHide={() => {
          setConfirmationModal(prev => ({
            ...prev,
            delete: false,
            updateStatus: false
          }));
          setCurrentItem({});
        }}
        show={confirmationModal.updateStatus}
        onClick={() => updateStatusTemplate()}
        modalTitle={`${
          currentItem.is_active ? "Non Aktifkan Template" : "Katfikan Template"
        }`}
        modalTitleContent={`Apakah kamu yakin ingin ${
          currentItem.is_active ? "Non Aktifkan Template" : "Katfikan Template"
        }?`}
      />
      <ConfirmationDeleteModal
        onHide={() => {
          setConfirmationModal(prev => ({
            ...prev,
            delete: false,
            updateStatus: false
          }));
          setCurrentItem({});
        }}
        show={confirmationModal.delete}
        onClick={() => deleteTemplate()}
        title={`Hapus template ${currentItem.name}`}
        content="Apakah kamu yakin ingin menghapus template ini?"
      />
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(
                  notificationTemplateUIProps.setQueryParams
                )}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: productsUIProps.ids,
                //   setIds: productsUIProps.setIds,
                // })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default NotificationTemplateTable;
